import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class GenericError extends Component {
  render() {
    const { err, css } = this.props;
    return err ? (
      <div className={css.errorWrapper}>
        <div role="alert" aria-live="assertive" className={css.errorMessage}>
          { err.errorMessage || err.errorCode || 'An error has occurred.' }
        </div>
      </div>
    ) : null;
  }
}

GenericError.propTypes = {
  err: PropTypes.object
};

export default styleable(defaultStyle) (GenericError);
